<template>
  <div>
    <!-- 实体区域 -->
    <div
      class="entity"
      id="entity"
      v-loading="loading"
      element-loading-background="rgba(16,164,178, 0.2)"
    ></div>
  </div>
</template>
<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      loading: false,
      echartsLink: [],
      echartsSource: [],
    };
  },
  components: {},
  props: ["analyze"],
  computed: {},
  beforeMount() {},
  mounted() {
    this.entity();
  },
  methods: {
    async entity() {
      this.loading = true;
      let data = { content: this.analyze };
      const { data: res } = await this.$http.post("/nlpir/extract", data);
      // console.log(res);
      this.loading = false;
      this.echartsLink = res.links;
      this.echartsSource = res.source;
      // 启动echarts
      this.echarts();
    },

    echarts() {
      var entity_echarts = echarts.init(document.getElementById("entity"));
      let date = this.echartsSource;
      let line = this.echartsLink;
      let datas = [];
      date.map((item, index) => {
        datas.push(Object.assign({}, item, { draggable: true }));
      });
      let liness = [];
      // 这里给每项数据添加value字段
      line.map((item, index) => {
        liness.push(Object.assign({}, item, { value: "" }));
      });
      // 这里把后台的数据转成图谱想要的数据  后台没拼  需要自己转
      const lines = liness.map((item) => {
        return {
          source: item.source + "",
          target: item.target + "",
          value: item.value,
        };
      });
      let option = {
        title: {
          text: "",
        },
        color: ["#BB8FCE", "#0099FF", "#5DADE2"],
        tooltip: {},
        animationDurationUpdate: 1500,
        series: [
          {
            type: "graph",
            layout: "force", //采用力引导布局
            symbolSize: 55,
            legendHoverLink: true, //启用图例 hover 时的联动高亮。
            focusNodeAdjacency: false, //在鼠标移到节点上的时候突出显示节点以及节点的边和邻接节点。
            roam: true,
            draggable: true, // 节点是否可拖拽
            label: {
              normal: {
                show: true,
                position: "inside",
                textStyle: {
                  fontSize: 14,
                  color: "#54f7ff",
                },
              },
            },
            lineStyle: {
              normal: {
                opacity: 0.7,
                color: "#54f7ff",
                width: 2,
                curveness: 0,
              },
            },
            itemStyle: {
              opacity: 0.7,
              normal: {
                color: {
                  type: "radial",
                  r: 0.9,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#0c1746",
                    },
                    {
                      offset: 1,
                      color: "#54f7ff",
                    },
                  ],
                },
                borderColor: "#54f7ff",
                borderWidth: 1,
              },
            },
            force: {
              repulsion: 1000,
            },

            edgeSymbolSize: [4, 50],
            edgeLabel: {
              normal: {
                show: true,
                textStyle: {
                  fontSize: 10,
                },
                formatter: "{c}",
              },
            },

            categories: [
              {
                // 节点分类

                label: {
                  formatter: "{b}",
                  fontSize: 20,
                  color: "#ffec19",
                },
                itemStyle: {
                  color: {
                    type: "radial",
                    r: 0.9,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#0c1746",
                      },
                      {
                        offset: 1,
                        color: "#ffec19",
                      },
                    ],
                  },
                  borderColor: "#ffec19",
                  borderWidth: 1,
                },
              },
              {
                label: {
                  formatter: "{b}",
                  fontSize: 20,
                  color: "#ffec19",
                },
                itemStyle: {
                  color: {
                    type: "radial",
                    r: 0.9,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#0c1746",
                      },
                      {
                        offset: 1,
                        color: "#ffec19",
                      },
                    ],
                  },
                  borderColor: "#ffec19",
                  borderWidth: 1,
                },
              },
              {
                label: {
                  formatter: "{b}",
                  fontSize: 12,
                  color: "#69a1ff",
                },
                itemStyle: {
                  color: {
                    type: "radial",
                    r: 0.9,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#0c1746",
                      },
                      {
                        offset: 1,
                        color: "#69a1ff",
                      },
                    ],
                  },
                  borderColor: "#69a1ff",
                  borderWidth: 1,
                },
              },
            ],
            data: datas,
            links: lines,
          },
        ],
      };
      entity_echarts.setOption(option);
      window.onresize = function () {
        entity_echarts.resize();
      };
    },
  },
  watch: {},
};
</script>
<style scoped>
.entity {
  width: 100%;
  height: 360px;
  box-sizing: border-box;
}
</style>
